export default "__VITE_ASSET__58fdd407__"